import React from 'react';
import { useDispatch } from 'react-redux';
import TextInput from 'common/components/TextInput/TextInput';
import { Trans } from 'react-i18next';
import { useCakeSelector } from 'app/rootReducer';
import {
  setLoginOtp,
} from 'views/Pages/Authentication/authSlice';

interface iOTPInputProps {
  onLogin?: () => void;
  isSubmitAutoTriggering?: boolean;
  showHelperText?: boolean,
}

const OTPInput = ({ onLogin, isSubmitAutoTriggering, showHelperText = true }: iOTPInputProps) => {
  const { loginOtp: otp } = useCakeSelector(state => state.auth);
  const dispatch = useDispatch();

  const onInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') { // enter
      if (isSubmitAutoTriggering) {
        e.preventDefault();
      }
      if (onLogin) {
        onLogin();
      }
    }
  };

  return (
    <React.Fragment>
      { showHelperText && <p><Trans>Enter two-factor authentication code from your authenticator app.</Trans></p> }
      <TextInput
        className="mb-24"
        type="text"
        placeholder='Authentication Code'
        label='Authentication Code'
        value={otp}
        onChange={value => dispatch(setLoginOtp(value))}
        tabIndex={3}
        onKeyDown={e => onInputKeyPress(e)}
        autoFocus={true}
        autoComplete='off'
      />
    </React.Fragment>
  );
};

OTPInput.defaultProps = {
  isSubmitAutoTriggering: false,
};

export default OTPInput;
